import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FormikValues } from 'formik';
import { UpdatePasswordParams } from 'types';
import UpdatePasswordForm from '../../components/templates/form-update-password';
import ConfirmForm from '../../components/templates/confirm-form';
import { ResetPasswordSelectors, ResetPasswordActions, AuthSelectors, AuthActions } from '../../common/config/store';
import Layout from '../../components/templates/layout';
import Card from '../../components/molecules/card';
import { useIntl } from '../../common/config/i18n';
import history from 'app-router/history';

const UpdatePassword: React.FC = () => {
  const { t } = useIntl();
  const dispatch = useDispatch();
  const status = useSelector(ResetPasswordSelectors.statusSelector);
  const isLoginExpired = useSelector(AuthSelectors.isLoginExpiredSelector);
  const isAuth = useSelector(AuthSelectors.isAuthSelector);

  // secure update-password page
  useEffect(() => {
    if (!isLoginExpired && !isAuth) {
      history.push('/login');
    }
  }, [isAuth, isLoginExpired]);

  const onSubmitHandler = (values: FormikValues) => {
    const updatePasswordParams: UpdatePasswordParams = {
      userName: values.userName,
      password: values.password,
      newPassword: values.newPassword,
    };
    dispatch(
      ResetPasswordActions.updatePassword({
        ...updatePasswordParams,
      })
    );
  };

  return (
    <div>
      <Layout login={isLoginExpired} />
      <div style={{ marginTop: '20px' }}>
        <Card title={isLoginExpired ? t('form', 'FORM_EXPIRED_PASSWORD') : t('form', 'FORM_RESET_PASSWORD')}>
          <>
            {status !== 'success' && <UpdatePasswordForm onSubmit={onSubmitHandler} />}
            {status === 'success' && (
              <ConfirmForm
                message={t('form', 'RESET_PASSWORD_OK')}
                onClick={() => dispatch(AuthActions.setIsLoginExpired(false))}
              />
            )}
          </>
        </Card>
      </div>
    </div>
  );
};
export default UpdatePassword;
